import { gql, useMutation } from '@apollo/client';
import { PROCESSING_CONSENT_FIELDS, ProcessingConsent } from './useAddProcessingConsentMutation';

const CONFIRM_PROCESSING_CONSENT = gql`
  ${PROCESSING_CONSENT_FIELDS}
  mutation ConfirmProcessingConsent($name: String!, $token: String!) {
    confirmProcessingConsent(name: $name, token: $token) {
      ...ProcessingConsentFields
    }
  }
`;

export interface ConfirmProcessingConsentInput {
  name: string;
  token: string;
}

export interface ConfirmProcessingConsentResult {
  confirmProcessingConsent: ProcessingConsent[];
}

export function useConfirmProcessingConsentMutation() {
  return useMutation<ConfirmProcessingConsentResult, ConfirmProcessingConsentInput>(CONFIRM_PROCESSING_CONSENT);
}
